export default {"src":"/_next/static/media/sixtAvenue.42c16990.svg","height":21,"width":113};